var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"message loading"},[_c('v-progress-linear',{attrs:{"indeterminate":"","color":"blue"}}),_c('v-alert',{attrs:{"show":"","type":"info"}},[_vm._t("default",function(){return [_vm._v("Loading message, please fill in the slot")]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }